<template>
  <li class="yj-timeline-item">
    <div class="yj-timeline-item__tail"></div>

    <div v-if="!$slots.dot"
      class="yj-timeline-item__node"
      :class="[
        `yj-timeline-item__node--${size || ''}`,
        `yj-timeline-item__node--${type || ''}`
      ]"
      :style="{
        backgroundColor: color
      }"
    >
      <i v-if="icon"
        class="yj-timeline-item__icon"
        :class="icon"
      ></i>
    </div>
    <div v-if="$slots.dot" class="yj-timeline-item__dot">
      <slot name="dot"></slot>
    </div>

    <div class="yj-timeline-item__wrapper">
      <div v-if="!hideTimestamp && placement === 'top'"
        class="yj-timeline-item__timestamp is-top">
        {{timestamp}}
      </div>

      <div class="yj-timeline-item__content">
        <slot></slot>
      </div>

      <div v-if="!hideTimestamp && placement === 'bottom'"
        class="yj-timeline-item__timestamp is-bottom">
        {{timestamp}}
      </div>
    </div>
  </li>
</template>

<script>
  export default {
    name: 'YjTimelineItem',

    inject: ['timeline'],

    props: {
      timestamp: String,

      hideTimestamp: {
        type: Boolean,
        default: false
      },

      placement: {
        type: String,
        default: 'bottom'
      },

      type: String,

      color: String,

      size: {
        type: String,
        default: 'normal'
      },

      icon: String
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/timeline/src/item.vue